module.exports = __webpack_public_path__ + "static/img/white-logo.0863a98.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/admin/white-logo.png
// module id = aLDw
// module chunks = 1